import lottie from "lottie-web";
import { defineElement } from "@lordicon/element";

export default defineNuxtPlugin(() => defineElement(lottie.loadAnimation))
